import { IGetState, TBoardId, TListId } from '../../../types/types';
import {
    EPushNotificationSettingsScope,
    EPushNotificationSettingsTypes,
    EPushNotificationSubscribeCases
} from '../../../types/rest/IRestPushNotificationSettings';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { pushNotificationSettingsPatchRest } from './api/helpers/pushNotificationSettingsPatchRest';

export const pushNotificationSet = (
    boardId: TBoardId,
    scope: EPushNotificationSettingsScope[],
    subscribeCases: EPushNotificationSubscribeCases[],
    types: EPushNotificationSettingsTypes[],
    moveToListIds: TListId[],
    listChangeToIds: TListId[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(pushNotificationSettingsPatchRest(boardId, {scope, subscribeCases, types, moveToListIds, listChangeToIds }));
    };
    return action;
}
